
<wiz-vgroup #vgMain width="100%" height="100%" padding="0px">
  <wiz-hgroup #hgDetailZone [visible]="hasFilter && showFilters" width="100%">
    <wiz-hgroup width="100%">
      <ng-container #containerFilter></ng-container>
    </wiz-hgroup>
    <wiz-hgroup width="50px" *ngIf="hasFilter" 
   horizontalAlign="end" verticalAlign="center">
      <wiz-icon #moreFilterIcon *ngIf="needMore" (click)="moreFilterPop()" 
          [wizTooltip]="'$.widget.more.filters.$'" tooltipPlacement="top"
          style="cursor: pointer; font-size: 20px"
          class="basicIcon black hoversave" >filters</wiz-icon>
      <wiz-icon *ngIf="hasActiveFilter" (click)="clearAllFilter()" 
        style="cursor: pointer; font-size: 20px"
        [wizTooltip]="'$.widget.clear.filters.$'" tooltipPlacement="top"
        class="basicIcon black hoversave" >cancel</wiz-icon>
    </wiz-hgroup>
  </wiz-hgroup>
  <wiz-ag-grid #agGrid
    width="100%"
    height="100%"
    [headerHeight]="headerHeight"
    [rowHeight]="rowHeight"
    [groupHeaderHeight]="groupHeaderHeight"
    [frameworkComponents]="gridFrameworkComponents"
    [wizDatasource]="finalDS"
    [wizRowSelection]="showRowSelection"
    [columnDefs]="columns"
    [gridOptions]="gridOptions"
    [groupIncludeFooter]="true"
    [widget]="widget"
    [customDeletionRenderer]="customDeletionRenderer"
    [wizShowDelete]="showRowDeletion"
    [customRowGroupRenderer]="customRowGroupRenderer"
    [wizShowGroup]="showRowGroup"
    class="ag-theme-alpine"
    (wizCellFile)="onCellFile($event)"
    (wizCellEdit)="onCellEdit($event)"
    (wizCellChecked)="onCellChecked($event)"
    (wizActionClicked)="onAction($event)"
    (wizImageClicked)="onImage($event)"
    (wizDeleteItem)="onItemDeleted($event)"
    (columnGroupOpened)="onColumnGroupEvent($event)"
    (wizGroupClicked)="onRowGroupEvent($event)"
    (collapseOrExpandGroups)="collapseOrExpandGroups($event)"
  ></wiz-ag-grid>

  <wiz-hgroup verticalAlign="center" width="100%" horizontalAlign="end" gap="0">
    <wiz-hgroup width="100%" horizontalAlign="end" gap="0">
      <wiz-icon *ngIf="computeMode && !!timeLabel" [ngClass]="computeDelta"  [wizTooltip]="'$.common.lastupdate.$'" tooltipPlacement="top">lightbulb</wiz-icon>
      <wiz-label [wizLabel]="timeLabel" width="80px" class="smallFont"></wiz-label>
      <ng-container #pageContainer ></ng-container>
    </wiz-hgroup> 
    <wiz-hgroup width="100px" horizontalAlign="end" style="padding-right: 5px;">
      <wiz-label [wizLabel]="countLabel" class="smallFont"></wiz-label>
    </wiz-hgroup>
    
  </wiz-hgroup>

</wiz-vgroup>
